<template>
  <div class="header-root">
  <!-- 手机端头部，保持与电脑端一致的布局 -->
  <header v-if="!isDesktop" class="header-component">
    <div class="header-content">
      <!-- 左侧部分 -->
      <div class="header-left">
        <!-- 手机端菜单按钮 -->
        <div class="menu-toggle" @click="toggleMenu">
          <i class="el-icon-menu"></i>
        </div>
        <!-- 手机端共享的 logo -->
        <div class="logo">
          <div class="logo-container">
            <img class="logo-image" src="@/assets/talin-logo-red-white.png" alt="国塔文化" />
            <span class="logo-text">国塔文化管理系统</span>
          </div>
        </div>
      </div>
      
      <!-- 中间部分，仅电脑端显示 -->
      <div class="header-middle"></div>
      
      <!-- 右侧用户信息 -->
      <div class="header-right">
        <!-- 用户信息和下拉菜单 -->
        <el-dropdown trigger="click">
          <div class="user-info">
            <el-avatar size="small" :src="userAvatar"></el-avatar>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- 通知选项 -->
            <el-dropdown-item @click.native="handleNotification">
              <i class="el-icon-bell"></i>
              <span>通知</span>
              <el-badge :value="noticeUnread" :hidden="noticeUnread === 0" class="item" style="margin-left: auto;"></el-badge>
            </el-dropdown-item>

            <!-- 消息选项 -->
            <el-dropdown-item @click.native="handleMessage">
              <i class="el-icon-message"></i>
              <span>消息</span>
              <el-badge :value="messageUnread" :hidden="messageUnread === 0" class="item" style="margin-left: auto;"></el-badge>
            </el-dropdown-item>
            
            <!-- 分隔线 -->
            <el-dropdown-item divided></el-dropdown-item>
            
            <!-- 通用选项 -->
            <el-dropdown-item @click.native="handlePersonalCenter">
              <i class="el-icon-user"></i>
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleChangePassword">
              <i class="el-icon-lock"></i>
              <span>修改密码</span>
            </el-dropdown-item>
            <!-- 推广二维码：取当前账号关联人员的推广码（没有关联人员时提示去设置） -->
            <el-dropdown-item @click.native="handlePromotionQr">
              <i class="el-icon-c-scale-to-original"></i>
              <span>推广二维码</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="handleLogout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>

  <!-- 电脑端使用原有结构 -->
  <header v-else class="header-component">
    <div class="header-content">
      <!-- 左侧部分 -->
      <div class="header-left">
        <!-- 电脑端和手机端共享的 logo -->
        <div class="logo">
          <div class="logo-container">
            <img class="logo-image" src="@/assets/talin-logo-red-white.png" alt="国塔文化" />
            <span class="logo-text">国塔文化管理系统</span>
          </div>
        </div>
      </div>

      <!-- 中间部分，仅电脑端显示 -->
      <div class="header-middle"></div>

      <!-- 右侧用户信息 -->
      <div class="header-right">
        <!-- 通知图标（我的通知：后台公告接收端） -->
        <div class="header-icon-item" @click="handleNotification">
          <el-badge :value="noticeUnread" :hidden="noticeUnread === 0" class="item">
            <i class="el-icon-bell"></i>
          </el-badge>
        </div>

        <!-- 分隔线 -->
        <div class="header-divider"></div>

        <!-- 消息图标（我的消息：业务提醒接收端） -->
        <div class="header-icon-item" @click="handleMessage">
          <el-badge :value="messageUnread" :hidden="messageUnread === 0" class="item">
            <i class="el-icon-message"></i>
          </el-badge>
        </div>
        
        <!-- 分隔线 -->
        <div class="header-divider"></div>
        
        <!-- 用户信息和下拉菜单 -->
        <el-dropdown trigger="click">
          <div class="user-info">
            <el-avatar size="small" :src="userAvatar"></el-avatar>
            <span class="user-company" v-if="companyName">{{ companyName }}</span>
            <span class="user-name">{{ userName }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- 通用选项 -->
            <el-dropdown-item @click.native="handlePersonalCenter">
              <i class="el-icon-user"></i>
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleChangePassword">
              <i class="el-icon-lock"></i>
              <span>修改密码</span>
            </el-dropdown-item>

            <!-- 推广二维码：取当前账号关联人员的推广码（没有关联人员时提示去设置） -->
            <el-dropdown-item @click.native="handlePromotionQr">
              <i class="el-icon-c-scale-to-original"></i>
              <span>推广二维码</span>
            </el-dropdown-item>

            <el-dropdown-item divided @click.native="handleLogout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>

  <!-- 推广二维码（与「人员管理 → 分享二维码」同一个弹窗组件，个人也能拿出来给客户扫） -->
  <person-qr-dialog
    :visible.sync="qrVisible"
    title="推广二维码"
    :person="qrPerson"
    :company-name="companyName"
    :position-label="qrPositionLabel"
  />
  </div>
</template>

<script>
// 顶栏入口（不进侧边栏菜单）：
// - 铃铛 → 我的通知（后台公告接收端，/mine/notice）
// - 信封 → 我的消息（业务提醒接收端，/mine/message）
// - 头像下拉 → 个人中心 /mine、修改密码 /mine/password、推广二维码（弹窗）、退出登录
// 未读角标：GET /mine/message/unread → 存 Vuex（unreadCount），组件挂载时拉一次；
// 消息页里标已读后会 dispatch('loadUnreadCount') 刷新，这里跟着变。
// 推广二维码：用当前账号的 person_id（tb_sys_admin.person_id）取该人员的推广码，
// 与扫码日志 share_user_id 同一口径；person_id=0（账号未关联人员）时只提示，不弹空码。

import PersonQrDialog from '@/components/PersonQrDialog.vue'
import { getProfile } from '@/api/mine'

export default {
  name: 'HeaderComponent',
  components: { PersonQrDialog },
  props: {
    isDesktop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 推广二维码弹窗
      qrVisible: false,
      qrPerson: {},
      qrPositionLabel: ''
    }
  },
  computed: {
    // 从Vuex store中获取用户名
    userName() {
      return this.$store.getters.getUserName || '管理员'
    },
    // 从Vuex store中获取用户头像
    userAvatar() {
      return this.$store.getters.getUserAvatar || ''
    },
    // 从Vuex store中获取所属公司名
    companyName() {
      return this.$store.getters.getCompanyName || ''
    },
    // 未读角标（我的通知）
    noticeUnread() {
      const counts = this.$store.getters.getUnreadCount || {}
      return Number(counts.notice) || 0
    },
    // 未读角标（我的消息）
    messageUnread() {
      const counts = this.$store.getters.getUnreadCount || {}
      return Number(counts.message) || 0
    }
  },
  created() {
    this.$store.dispatch('loadUnreadCount')
  },
  methods: {
    toggleMenu() {
      this.$emit('toggle-menu')
    },
    // 铃铛 → 我的通知
    handleNotification() {
      this.$router.push('/mine/notice')
    },
    // 信封 → 我的消息
    handleMessage() {
      this.$router.push('/mine/message')
    },
    // 处理个人中心点击事件
    handlePersonalCenter() {
      // 跳转到个人中心页面
      this.$router.push('/mine')
    },
    // 处理设置点击事件
    handleSettings() {
      // 这里可以添加设置点击后的逻辑
      console.log('设置点击')
    },
    // 处理退出登录点击事件
    handleLogout() {
      // 这里可以添加退出登录点击后的逻辑
      console.log('退出登录点击')
      // 调用Vuex store的退出登录方法
      this.$store.dispatch('logout')
      // 跳转到登录页
      this.$router.push('/login')
    },
    // 修改密码 → 独立页面
    handleChangePassword() {
      this.$router.push('/mine/password')
    },
    // 推广二维码：当前账号关联人员（tb_sys_admin.person_id）的推广码
    // 姓名/岗位/链接/二维码由 GET /system/person/{id}/share-qr 下发，这里只传 id
    // 每次都向 /mine/info 取最新 person_id：关联人员可被管理员在「账号管理」里随时改，
    // 而登录缓存只是登录那一刻的快照（store 还会把缺失值归一成 0），据此判断必然误报「未关联」。
    // 接口异常时退回缓存里的值，避免网络抖动导致入口直接不可用。
    handlePromotionQr() {
      const info = this.$store.getters.getUserInfo || {}
      getProfile().then(res => {
        const body = (res && res.code === 200 && res.data) ? res.data : null
        if (!body) {
          this.openPromotionQr(Number(info.person_id) || 0)
          return
        }
        const pid = Number(body.person_id) || 0
        // 回写缓存：别的页面/下次兜底都能拿到最新值
        this.$store.commit('updateUserInfo', { person_id: pid })
        this.openPromotionQr(pid)
      }).catch(() => {
        this.openPromotionQr(Number(info.person_id) || 0)
      })
    },
    openPromotionQr(personId) {
      if (!personId) {
        this.$message.warning('当前账号未关联人员，请先在「账号管理」里设置关联人员')
        return
      }
      this.qrPerson = { id: personId }
      this.qrPositionLabel = ''
      this.qrVisible = true
    }
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */

/* 外层容器只用于挂弹窗：header 是 fixed，这里不占位，避免撑出 80px 空白 */
.header-root {
  height: 0;
  overflow: visible;
}

/* 头部基础样式：与左侧菜单同为深棕黑（--menu-bg），上下一体 */
.header-component {
  background-color: var(--menu-bg, #160400);
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  height: 80px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 头部内容容器 */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}

/* 电脑端样式：左右两边贴近边缘 */
@media (min-width: 769px) {
  .header-content {
    max-width: none;
    margin: 0;
    padding: 0 30px;
  }
}

/* 左侧部分 */
.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 菜单按钮 */
.menu-toggle {
  font-size: 24px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  transition: opacity 0.3s;
}

.menu-toggle:hover {
  opacity: 1;
  color: #fff;
}

/* Logo 基础样式 */
.logo {
  display: flex;
  align-items: center;
}

/* Logo 容器 */
.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
}
.logo-image {
  flex: 0 0 auto;
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.logo-text {
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.06em;
  white-space: nowrap;
}

/* Logo 图标 */
.logo-icon {
  width: 40px;
  height: 40px;
  background-color: #a67c52;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
}

/* Logo 图标内部的线条 */
.logo-icon::before,
.logo-icon::after {
  content: '';
  position: absolute;
  background-color: white;
  border-radius: 50%;
}

/* 左侧半圆 */
.logo-icon::before {
  width: 30px;
  height: 30px;
  top: 5px;
  left: 0;
  border: 5px solid #a67c52;
  border-right-color: transparent;
}

/* 右侧半圆 */
.logo-icon::after {
  width: 20px;
  height: 20px;
  top: 5px;
  right: 0;
  border: 5px solid #a67c52;
  border-left-color: transparent;
}

/* Logo 文字部分 */
.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

/* 中文名称 */
.logo-chinese {
  font-size: 18px;
  font-weight: 700;
  color: #a67c52;
  line-height: 1;
  margin: 0;
}

/* 英文名称，仅电脑端显示 */
.logo-english {
  font-size: 10px;
  font-weight: 500;
  color: #a67c52;
  line-height: 1;
  margin: 2px 0 0 0;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* 中间部分 */
.header-middle {
  flex: 1;
}

/* 右侧部分 */
.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 图标项样式，仅电脑端显示 */
.header-icon-item {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: opacity 0.3s;
}

.header-icon-item:hover {
  opacity: 1;
  color: #fff;
}

/* 分隔线样式，仅电脑端显示 */
.header-divider {
  width: 1px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.18);
  margin: 0 5px;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  transition: opacity 0.3s;
}

.user-info:hover {
  opacity: 1;
  color: #fff;
}

.user-info i {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

/* 用户头像样式 */
.user-info .el-avatar {
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 14px;
}

/* 用户名样式，仅电脑端显示 */
.user-company {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  margin-right: 8px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

/* 响应式调整 */
@media (max-width: 768px) {
  /* 手机端英文名称不显示 */
  .logo-english {
    display: none;
  }
  
  /* 手机端头像右侧只显示箭头 */
  .user-info {
    gap: 5px;
  }
}
</style>